var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 23c-1.3 0-2.6-.2-3.8-.7-2.2-.8-4.1-2.3-5.4-4.3s-1.9-4.4-1.7-6.7c.2-2.4 1.1-4.6 2.6-6.4s3.6-3.1 5.9-3.6 4.7-.3 6.9.7c.5.2.7.8.5 1.3s-.8.7-1.3.5c-1.8-.8-3.8-1-5.6-.6-2 .4-3.7 1.5-4.9 3-1.3 1.5-2 3.3-2.1 5.3-.1 1.9.4 3.9 1.4 5.5s2.6 2.9 4.4 3.5c1.8.7 3.8.7 5.7.2 1.8-.5 3.5-1.7 4.7-3.2s1.8-3.5 1.8-5.4v-.9c0-.6.4-1 1-1s1 .4 1 1v.8c0 2.4-.8 4.7-2.2 6.6s-3.4 3.3-5.7 4c-1.1.2-2.1.4-3.2.4zm0-8c-.3 0-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.3 2.3 9.3-9.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-10 10c-.2.2-.4.3-.7.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.34ae7e23b6e46a186f13f9adcf63d31e.svg";
export { ForwardRef as ReactComponent };